import React from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  IconButton,
  Toolbar,
  Divider,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';

import { sections } from '.';

export default function Sidebar({

  selectedIndex,
  onSelect,
  drawerWidth,
}) {


  const Mini = styled(Drawer)(
    ({ theme, open }) => ({
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
        position: "relative", //imp
    width: 240, //drawer width
    "& .MuiDrawer-paper": {
      width: 240, //drawer width
      position: "absolute", //imp
      transition: "none !important"
    }
    })
  );

  return (
    <Mini variant="permanent" >

      <List>
        {sections.map((sec, idx) => (
          <ListItemButton
            key={sec.title}
            selected={selectedIndex === idx}
            onClick={() => onSelect(idx)}
            sx={{
              px: 2.5,
            }}
          >
            <ListItemText primary={sec.title} sx={{ opacity: 1 }} />
          </ListItemButton>
        ))}
      </List>
    </Mini>
  );
}
